import React from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import UserDetails from "../components/user-profile-lite/UserDetails.js"
import UserAccountDetails from "../components/user-profile-lite/UserAccountDetails.js"
import "./UserProfileLite.css";

const UserProfileLite = () => {
  const { t } = useTranslation();

  return (
  <Container fluid className="main-content-container user-profile-page">
    <header className="user-profile-header">
      <div className="user-profile-title">
        <span className="user-profile-eyebrow">SMARTFARM</span>
        <h1>{t("profile_title", { defaultValue: "Mon profil" })}</h1>
        <p>
          {t("profile_subtitle", {
            defaultValue: "Gérez vos informations personnelles, votre photo et la sécurité de votre compte.",
          })}
        </p>
      </div>
      <div className="user-profile-header-badge">
        <span><i className="fas fa-shield-alt" aria-hidden="true" /></span>
        <div>
          <strong>{t("profile_private_space", { defaultValue: "Espace personnel" })}</strong>
          <small>{t("profile_secure_data", { defaultValue: "Vos données sont sécurisées" })}</small>
        </div>
      </div>
    </header>

    <div className="user-profile-layout">
      <aside className="user-profile-aside">
        <UserDetails />
      </aside>
      <main className="user-profile-main">
        <UserAccountDetails />
      </main>
    </div>
  </Container>
  );
};

export default UserProfileLite;
